import Icon from '@material-ui/icons/Visibility';
import React from 'react';
import { Filter, ResourceList } from '../../controllers';
import { DateTimeField, EnumField, LinkField, NumberField } from '../../fields';
import { BooleanInput } from '../../inputs';



export default {
  Icon,
  dialogs: {
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <LinkField
          displaySource="title"
          reference="streaming_streams"
          source="stream_id"
        />
        <LinkField
          reference="users"
          source="user_id"
        />
        <EnumField
          source="status"
        />
        <NumberField
          source="seconds_watched"
        />
        <DateTimeField
          source="last_ping_at"
        />
        <DateTimeField
          source="last_left_at"
        />
        
      </ResourceList>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
